import {AdvertisementVastInput, Advertisements} from "../state/input";
import {
    AdvertisementVast,
    Advertisement as AdvertisementOutput,
    SourceAction
} from "../state/source";


import {VASTClient} from "vast-client";
//import MobileDetect from "mobile-detect";

// @ts-ignore
//import { urlHandler } from 'vast-client/src/url_handler';

import {buffers, TakeableChannel, Task} from "redux-saga";
import {AdvertisementAction} from "../state/types";
import {actionChannel, race, fork, put, take, delay, select, call} from "redux-saga/effects";
import {AppState} from "../state";
import {WaitingTime} from "../state/waitingtime";
import {GDPR} from "../state/gdpr";
import {gdpr} from "./gdpr";
import {
    AudioAdvertisementTiming,
    AudioAdvertisementTimingAddAction,
} from "../state/audioadvertisementtiming";
import {IsMobile} from "./utils";
import {ApiClient} from "../../../generated/ApiClient";


/**
 * https://ad.doubleclick.net/ddm/pfadx/N1018932.1914880EXTRA/B26352556.312308221;sz=0x0;ord=[timestamp];dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=;dcmt=text/xml;dc_sdk_apis=[APIFRAMEWORKS];dc_omid_p=[OMIDPARTNER];dc_vast=3;gdpr=${GDPR};gdpr_consent=${GDPR_CONSENT_755};ltd=
 * APIFRAMEWORKS
 *
 *
 * @param source
 * @param gdpr
 * @constructor
 */


const Vast = async (source: AdvertisementVastInput, gdpr?: GDPR) => {

    const vastClient = new VASTClient() as VASTClient;
    vastClient.getParser().addURLTemplateFilter(url => {
        url = url.replace("[timestamp]", new Date().getTime() + '').replace("%%ADFRND%%", new Date().getTime() + '');

        if (gdpr) {
            url = url.replace(/%5BGDPR%5D|\[GDPR]|\${GDPR}/gi, gdpr.gdprApplies ? '1' : '0')
                .replace(/%5BGDPRCONSENT%5D|\${GDPR_CONSENT_[0-9]+}/gi, gdpr.tcString)
        } else {
            url = url.replace(/%5BGDPR%5D|\[GDPR]|\${GDPR}/gi, '0')
                .replace(/%5BGDPRCONSENT%5D|\[GDPRCONSENT]|\${GDPR_CONSENT_[0-9]+}/gi, '')
        }
        return url;
    })

    try {
        const response = await vastClient.get(source.url);
        if (response.ads.length !== 0) {
            return {
                id: source.id,
                type: "AdvertisementVast",
                content: response,
                hours: source.hour
            } as AdvertisementVast
        }
        return false;
    } catch (e) {
        return false;
    }
}

export function* LoadAdvertisement(source: Advertisements, slug: string) {

    if (!source) {
        return false;
    }

    const advtime: WaitingTime = yield select((state: AppState) => state.waitingTime);
    const advplayed: AudioAdvertisementTiming[] = yield select((state: AppState) => state.audioAdvertisementTiming);
    for (let i = 0; i < source.length; i++) {
        const now = source[i];
        if (!now)
            continue;
        const id = now.id;

        if (now.hour && advplayed.some(x => {
            if (x.id === id && x.slug == slug)
            {
                const d = new Date();
                d.setTime(x.validTo);
                if (d > new Date())
                    return true;
            }
            return false;
        })) {
            continue;
        }


        switch (now.type) {
            case 'vast': {
                if (IsMobile()) {
                    if (!now.onMobile) {
                        continue;
                    }
                }

                const hasGdpr: GDPR = yield call(gdpr);

                const {output, timeout}: { output: AdvertisementVast, timeout: boolean } = yield race({
                    output: Vast(now, hasGdpr),
                    timeout: delay(advtime.advloadtime),
                })

                if (timeout || !output )
                    continue;
                return output;
            }
        }
    }
    return false;
}

export function* ProcessAdvertisement(o: AdvertisementOutput, slug: string, uuid: string) {
    const {advtime}: {
        advtime: WaitingTime
    } = yield select((state: AppState) => ({advtime: state.waitingTime, id: state.id}));
    if (o) {

        const channel: TakeableChannel<AdvertisementAction> = yield actionChannel(['AdvertisementBegin', 'AdvertisementEnd', 'AdvertisementError', 'AdvertisementPlay'], buffers.sliding(3));

        const advBeginTask: Task = yield fork(function* () {
            yield delay(advtime.advloadtime);
            new ApiClient().postApiStatisticsPlayer({
                frontWebStatisticsPlayerModel: {
                    uuid,
                    isMobile: IsMobile(),
                    state: "error_prepare_advertisement",
                }
            }, {
                credentials: "omit"
            })
            yield put<AdvertisementAction>({
                type: "AdvertisementError",
                payload: "ERROR_PREPARE_ADVERTISEMENT"
            });
        });

        const advPlayTask: Task = yield fork(function* () {
            yield delay(advtime.advwaitingtime);
            new ApiClient().postApiStatisticsPlayer({
                frontWebStatisticsPlayerModel: {
                    uuid,
                    isMobile: IsMobile(),
                    state: "error_play_advertisement",
                }
            }, {
                credentials: "omit"
            })
            yield put<AdvertisementAction>({
                type: "AdvertisementError",
                payload: "ERROR_STARTPLAYING_ADVERTISEMENT"
            })
        })


        yield put<SourceAction>({
            type: "Source",
            payload: o
        });

        while (true) {
            const action: AdvertisementAction = yield take<AdvertisementAction>(channel);
            switch (action.type) {
                case 'AdvertisementError':
                    advPlayTask.cancel();
                    advBeginTask.cancel();
                    return false;
                case 'AdvertisementBegin':
                    advBeginTask.cancel();
                    break;
                case 'AdvertisementPlay':
                    advPlayTask.cancel();
                    new ApiClient().postApiStatisticsPlayer({
                        frontWebStatisticsPlayerModel: {
                            uuid,
                            isMobile: IsMobile(),
                            state: "playing_advertisement",
                        }
                    }, {
                        credentials: "omit"
                    })
                    break;
                case "AdvertisementEnd":
                    new ApiClient().postApiStatisticsPlayer({
                        frontWebStatisticsPlayerModel: {
                            uuid,
                            isMobile: IsMobile(),
                            state: "played_advertisement",
                        }
                    }, {
                        credentials: "omit"
                    });
                    const d = new Date();
                    if (!o.hours)
                        return true;

                    const time = d.getTime() + o.hours * 60 * 60 * 1000
                    d.setTime(time);
                    yield put<AudioAdvertisementTimingAddAction>({
                        type: "AudioAdvertisementTimingAdd",
                        payload: {
                            id: o.id,
                            validTo: d.getTime(),
                            slug: slug
                        }
                    });
                    return true;
                default:
                    return true;
            }
        }
    }
}

